/* @ngInject */
function SocialMediaPostPreviewController ($scope) {
  const api = {}

  this.getApi = () => api

  activate()
  function activate () {}

  $scope.getTemplateName = (template) => {
    const templateName = template?.name
    const templateAsset = template?.asset

    if (templateAsset) {
      const assetName = templateAsset.name
      const extension = templateAsset.extension

      return `${assetName}.${extension}`
    }

    if (templateName) {
      return templateName
    }

    return ''
  }

  $scope.getDisplayImage = () => {
    if ($scope.selectedMaterial) {
      return $scope.selectedMaterial.url || $scope.selectedMaterial.thumbnail
    }
    return $scope.previewUrl
  }

  $scope.getDisplayName = () => {
    if ($scope.selectedMaterial) {
      return $scope.selectedMaterial.name || $scope.getTemplateName($scope.template)
    }
    return $scope.getTemplateName($scope.template)
  }
}

export { SocialMediaPostPreviewController }
